<script setup lang="ts">
/**
 * リプライ情報 > 投稿日。
 */
import { defineProps } from "vue";
import DateUtil from "@/modules/utils/dateUtil";

interface Props {
	/**
	 * リプライ投稿日。
	 */
	replyDate: string;
}
const props = defineProps<Props>();

/**
 * 投稿日を表示用形式に変換。
 * ユーザーの入力値で動的に変更される値ではない為、reactiveにする必要はなし。
 */
const convertDate: string = DateUtil.convertDiplayFormat(props.replyDate);
</script>

<template>
	<p class="revico-community-talk-talkroom-details--date">{{ convertDate }}</p>
</template>

<style lang="scss">
.revico-widget .revico-community-talk .revico-community-talk {
	.revico-community-talk-reply-details {
		&--date {
			width: 7em;
			margin: 0;
			font-size: 0.8em;
			text-align: right;
		}
	}
}
</style>
